module.exports = __webpack_public_path__ + "img/chargingpoint-fastcharger-definitive.42236b0b.png";